<template>
  <router-view/>
</template>

<script>
  import RouteEntryMixin from '@com/mixins/route-entry'

  export default {
    name: 'history',
    mixins: [RouteEntryMixin],
    data: _ => ({
      routes: [
        { path: '/history/index', label: 'History' }
      ]
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/app/history/History.Entry.vue